import { InvestmentHoldingModel } from 'src/types/investment-holding.model';
import * as H from 'history';
import { FullUserModel } from 'src/types/user.model';

export class InvestmentDrawerViewModel {
    currentInvestment: InvestmentHoldingModel;
    typeFromURL: string;
    history: H.History;
    handleOpenConfirmation: (confirmation: any) => void;
    handleBack: () => void;
    handleTopDrawer: () => void;
    onStartupStep: boolean;
    realEstateCount: number;
    handleReloadUser: () => void;
    firstImport: boolean;
    handleAccounts: () => Promise<void>;
    handleClearFirstImport: () => void;
    handleFirstImport: () => void;
    setDrawer: () => void;
    user: FullUserModel;
}
